module.exports = __webpack_public_path__ + "img/Custom Size – 1.67707b5f.jpg";